<script lang="ts" setup>
interface AppPageProps {
  fluid?: boolean;
}

withDefaults(defineProps<AppPageProps>(), {
  fluid: false,
});
</script>

<template>
  <VContainer class="page pa-6" :fluid="fluid">
    <slot />
  </VContainer>
</template>

<style lang="scss" scoped>
.page {
  min-height: 100%;
}
</style>
